export default __webpack_public_path__ + "static/media/threeTomoea.7df6335d.png";